import React, { useCallback } from 'react'
import Select from 'react-select'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { isDateAfter, isDateBefore } from '../../helper/function'
import CommonDateTimePicker from '../../component/commonDateTimePicker'

const PaymentFilter = ({
  showFilter,
  setShowFilter,
  setFilterData,
  handlePendingPaginationChange,
  handlePaidPaginationChange,
  handleFailedPaginationChange,
  handleExitsPaginationChange,
  handleInvoiceOffPaginationChange,
  onFilterClear
}) => {
  const collapse = true
  const { handleSubmit, control, trigger, reset, watch } = useForm({})
  const { allRegion } = useSelector(({ region }) => region)

  // const CleaningStatus = useMemo(
  //   () => [
  //     {
  //       key: 'PENDING',
  //       label: 'Pending',
  //       backKey: 'pending'
  //     },
  //     {
  //       key: 'SUCCEEDED',
  //       label: 'Succeeded',
  //       backKey: 'succeeded'
  //     },
  //     {
  //       key: 'FAILED',
  //       label: 'Failed',
  //       backKey: 'failed'
  //     },
  //     {
  //       key: 'REFUNDED',
  //       label: 'Refunded',
  //       backKey: 'refunded'
  //     },
  //     {
  //       key: 'PAID',
  //       label: 'Paid',
  //       backKey: 'paid'
  //     },
  //     {
  //       key: 'WAITING_CHARGE',
  //       label: 'Waiting Charge',
  //       backKey: 'waiting_charge'
  //     },
  //     {
  //       key: 'WAITING_CAPTURE',
  //       label: 'Waiting Capture',
  //       backKey: 'waiting_capture'
  //     },
  //     {
  //       key: 'PENDING_INVOICE',
  //       label: 'Pending Invoice',
  //       backKey: 'pending_invoice'
  //     },
  //     {
  //       key: 'DEEP_CLEANINGS_ONLY',
  //       label: 'See Only Deep Cleanings',
  //       backKey: 'deep_cleanings_only'
  //     }
  //   ],
  //   []
  // )

  const handleFilterclear = useCallback(() => {
    reset({
      created_start: '',
      created_end: '',
      cleaner: '',
      hostname: '',
      region: ''
    })
    setFilterData({})
    setShowFilter(false)
    handlePendingPaginationChange(1, 10)
    handlePaidPaginationChange(1, 10)
    handleFailedPaginationChange(1, 10)
    handleExitsPaginationChange(1, 10)
    handleInvoiceOffPaginationChange(1, 10)
  }, [showFilter])

  React.useEffect(() => {
    if (onFilterClear) {
      onFilterClear(handleFilterclear)
    }
  }, [onFilterClear, handleFilterclear])

  const onSubmit = useCallback(
    (data) => {
      // const booking_status = CleaningStatus.filter((status) => data?.[status.key]).map((status) => status.backKey)
      setFilterData({
        created_start: data?.created_start ? data?.created_start : undefined,
        created_end: data?.created_end ? data?.created_end : undefined,
        cleaner: data?.cleaner,
        hostname: data?.hostname,
        region: data?.region?.region_id
        // booking_status: booking_status
      })
      handlePendingPaginationChange(1, 10)
      handlePaidPaginationChange(1, 10)
      handleFailedPaginationChange(1, 10)
      handleExitsPaginationChange(1, 10)
      handleInvoiceOffPaginationChange(1, 10)
      setShowFilter(!showFilter)
    },
    [showFilter]
  )

  return (
    <div className={`toggle-sidebar ${showFilter ? 'open-filter' : ''}`}>
      <div className="sidebar-layout-filter">
        <div className="sidebar-header">
          <h5>Filter</h5>
          <Link
            to="#"
            className="sidebar-closes"
            onClick={() => {
              setShowFilter(!showFilter)
            }}
          >
            <i className="fa-regular fa-circle-xmark" />
          </Link>
        </div>

        <div className="sidebar-body">
          <div className="title">Payment</div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="accordion" id="accordionMain1">
              <div
                id="collapseOne"
                className={collapse ? 'collapse show' : 'collapse'}
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1"
              >
                <div className="card-body-chat">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group">
                        <label>Cleaner</label>
                        <Controller
                          name="cleaner"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <>
                              <input
                                className="form-control bg-transparent dark_border"
                                autoComplete="off"
                                value={value}
                                type="text"
                                placeholder="Search Cleaner Name"
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('name')
                                }}
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group">
                        <label>Host</label>
                        <Controller
                          name="hostname"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <>
                              <input
                                className="form-control bg-transparent dark_border"
                                autoComplete="off"
                                value={value}
                                type="text"
                                placeholder="Search Host Name"
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('name')
                                }}
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group input_text border-remove dark_border_divs">
                        <label>Region</label>
                        <Controller
                          name="region"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              className={`react-selectcomponent form-control select-box-filed`}
                              getOptionLabel={(option) => `${option.region}`}
                              getOptionValue={(option) => `${option.region_id}`}
                              options={allRegion || []}
                              isClearable
                              isSearchable={true}
                              placeholder={`Select Region`}
                              classNamePrefix="select_kanakku"
                              defaultValue={''}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {/* <label style={{ color: 'black' }}>Date</label> */}
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>From:</label>
                        <div className="date_picker_main_div">
                          <CommonDateTimePicker
                            name="created_start"
                            control={control}
                            className="form-control bg-transparent dark_border"
                            placeholder="DD/MM/YYYY"
                            disablePast={false}
                            onDateChange={() => {
                              trigger('created_start')
                            }}
                            shouldDisableDate={(date) => isDateAfter(date, watch('created_end'))}
                            type="DatePicker"
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>To:</label>
                        <div className="date_picker_main_div">
                          <CommonDateTimePicker
                            name="created_end"
                            control={control}
                            className="form-control bg-transparent dark_border"
                            placeholder="DD/MM/YYYY"
                            disablePast={false}
                            onDateChange={() => {
                              trigger('created_end')
                            }}
                            shouldDisableDate={(date) => isDateBefore(date, watch('created_start'))}
                            type="DatePicker"
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group input_text border-remove">
                        <label>Cleaning status</label>
                        {CleaningStatus?.map((status, index) => (
                          <Controller
                            key={`status-control-${index}`}
                            name={status?.key}
                            control={control}
                            // checked={true}
                            defaultValue={false}
                            render={({ field }) => (
                              <Form.Check
                                type="switch"
                                id={`custom-switch-${index}`}
                                label={`${status?.label}`}
                                {...field}
                                checked={field.value} // ensures checked state is bound to value
                              />
                            )}
                          />
                        ))}
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            {/* Filter Button */}
            <div className="filter-buttons">
              <button
                type="submit"
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary mb-1"
                // className="d-inline-flex align-items-center justify-content-center btn w-100 sky_btn mb-1"
              >
                {' '}
                Apply
                {/* cleaning count: {allOverview?.totalRecords || 0} */}
              </button>
              <button
                type="button"
                onClick={handleFilterclear}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-secondary"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PaymentFilter
